// src/components/recent-searches/recent-searches.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSlimCardFragment on TripsSlimCard {\n    primary\n    subTexts {\n      ... on EGDSPlainText {\n        text\n      }\n    }\n    graphic {\n      ... on Icon {\n        id\n        description\n        token\n      }\n    }\n    action {\n      ... on TripsNavigateToViewAction {\n        viewUrl\n        viewType\n        analytics {\n          referrerId\n          linkName\n          eventType\n        }\n      }\n    }\n    impressionTracking {\n      uisPrimeAnalytics {\n        linkName\n        eventType\n        referrerId\n      }\n    }\n    accessibility {\n      label\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment RecentSearchesCarouselFragment on TripsRecentSearchesResponseSuccess {\n    heading\n    carousel {\n      elements {\n        ...TripsSlimCardFragment\n      }\n      accessibility {\n        ... on TripsCarouselAccessibilityData {\n          nextButton\n          prevButton\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query RecentSearchesQuery($context: ContextInput!) {\n    trips(context: $context) {\n      recentSearches {\n        ...RecentSearchesCarouselFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React3 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/recent-searches/__private/__fragments/recent-searches-carousel.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// src/components/recent-searches/__private/__fragments/slim-card.tsx
import React from "react";
import { gql } from "@apollo/client";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var SlimCard = function(param) {
    var data = param.data;
    var primary = data.primary, subTexts = data.subTexts, graphic = data.graphic, action = data.action, impressionTracking = data.impressionTracking, accessibility = data.accessibility;
    var clickTracker = useClickTracker();
    var subTextsElements = Array.isArray(subTexts) && (subTexts === null || subTexts === void 0 ? void 0 : subTexts.map(function(subheading, subheadingIndex) {
        if (subheading.__typename === "EGDSPlainText") {
            return /* @__PURE__ */ React.createElement(UitkText, {
                overflow: "wrap",
                size: 300,
                spacing: "one",
                key: "trip-subheading-".concat(subheadingIndex)
            }, subheading.text);
        }
        return null;
    }));
    var generateUniqueId = React.useMemo(function() {
        return function(id) {
            return id + Math.random().toString(36).slice(2, -1);
        };
    }, []);
    var _accessibility_label;
    var cardContent = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: primary && !subTexts ? {
            block: "two"
        } : "unset",
        padding: {
            block: "four",
            inline: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React.createElement(React.Fragment, null, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkIcon, {
        title: graphic.description,
        id: generateUniqueId(graphic.id),
        name: graphic.id,
        size: UitkIconSize.MEDIUM
    })))), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React.createElement("div", null, primary && /* @__PURE__ */ React.createElement(UitkText, {
        weight: "bold",
        size: 400,
        overflow: "truncate-2-lines"
    }, primary), subTextsElements)))))), (action === null || action === void 0 ? void 0 : action.__typename) === "TripsNavigateToViewAction" && /* @__PURE__ */ React.createElement(UitkCardLink, null, /* @__PURE__ */ React.createElement("a", {
        href: action.viewUrl,
        onClickCapture: function() {
            return clickTracker(action.analytics.referrerId, action.analytics.linkName);
        },
        target: "_blank",
        rel: "noopener"
    }, (_accessibility_label = accessibility === null || accessibility === void 0 ? void 0 : accessibility.label) !== null && _accessibility_label !== void 0 ? _accessibility_label : "")));
    return /* @__PURE__ */ React.createElement(UitkCard, {
        border: true,
        overflow: true,
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, (impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.uisPrimeAnalytics) ? /* @__PURE__ */ React.createElement(IntersectionTracker, {
        referrerId: impressionTracking.uisPrimeAnalytics.referrerId,
        linkName: impressionTracking.uisPrimeAnalytics.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, cardContent) : /* @__PURE__ */ React.createElement(React.Fragment, null, cardContent))));
};
SlimCard.fragment = fragment;
SlimCard.displayName = "SlimCard";
// src/components/recent-searches/__private/__fragments/recent-searches-carousel.tsx
var fragment2 = gql2(_templateObject1(), SlimCard.fragment);
var RecentSearchesCarousel = function(param) {
    var data = param.data, className = param.className;
    var carousel = data.carousel;
    if (!carousel || carousel.elements.length === 0) {
        return null;
    }
    var accessibility = carousel.accessibility, elements = carousel.elements;
    var carouselElements = elements.map(function(element, elementIndex) {
        if (element.__typename === "TripsSlimCard") {
            return /* @__PURE__ */ React2.createElement(SlimCard, {
                data: element,
                key: "recent-searches-slim-card-".concat(elementIndex)
            });
        }
        return null;
    });
    var carouselProps = {
        buttonText: {
            nextButton: (accessibility === null || accessibility === void 0 ? void 0 : accessibility.__typename) === "TripsCarouselAccessibilityData" && accessibility.nextButton ? accessibility.nextButton : "",
            prevButton: (accessibility === null || accessibility === void 0 ? void 0 : accessibility.__typename) === "TripsCarouselAccessibilityData" && accessibility.prevButton ? accessibility.prevButton : ""
        },
        carouselName: "RecentSearchesCarousel",
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 4
        },
        itemsMaxHeight: true,
        pageBy: 1,
        peek: true,
        children: carouselElements
    };
    return /* @__PURE__ */ React2.createElement("div", {
        className: className
    }, /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(UitkHeading, {
        overflow: "truncate-2-lines",
        tag: "h2",
        size: 5
    }, data.heading)), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(UitkHeading, {
        overflow: "truncate-2-lines",
        tag: "h2",
        size: 4
    }, data.heading))), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React2.createElement(UitkCarousel, _object_spread({}, carouselProps))));
};
RecentSearchesCarousel.fragment = fragment2;
RecentSearchesCarousel.displayName = "RecentSearchesCarousel";
// src/components/recent-searches/recent-searches.tsx
var __Query = gql3(_templateObject2(), RecentSearchesCarousel.fragment);
var RecentSearches = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, className = props.className;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || data.trips.recentSearches.__typename !== "TripsRecentSearchesResponseSuccess") {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(RecentSearchesCarousel, {
        data: data.trips.recentSearches,
        className: className
    });
};
RecentSearches.displayName = "sharedui-RecentSearches";
export { RecentSearches };
//# sourceMappingURL=index.js.map